import React, { useEffect, useState } from "react";
import "./BetHistoryPage.css";
import { authService } from "../services/authService";

const ContactUs = () => {
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState(null);
  const [error, setError] = useState("");

  const token = authService.getToken();

  useEffect(() => {
    const fetchContact = async () => {
      if (!token) {
        setError("Session expired. Please login again.");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `https://playinbyd.com/api/admin/get-contact-settings?accessing=8-8&unique_jwt_token=${token}`
        );

        const data = await res.json();
        console.log("Contact API:", data);

        if (data?.success && data?.contact_data) {
          setContact(data.contact_data);
        } else {
          setError("Failed to load contact details");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load contact details");
      } finally {
        setLoading(false);
      }
    };

    fetchContact();
  }, [token]);

  // Helper function to clean up telegram username
  const cleanTelegramUsername = (username) => {
    if (!username) return "";
    // Remove extra @ symbols and trim whitespace
    return username.replace(/@+/g, '@').trim();
  };

  // Helper function to check if field has valid value
  const hasValidValue = (value) => {
    return value && value.toString().trim() !== "" && 
           value !== "undefined" && value !== "null";
  };

  return (
    <div className="bet-history-page">
      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">Reach our support team anytime</p>
        </div>

        {/* <div className="user-info-card">
          <div className="user-details">
            <div className="user-name">Support Center</div>
            <div className="user-mobile">We are here to help you</div>
          </div>
        </div> */}
      </div>

      {/* CONTENT */}
      <div className="content-card">
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading contact details...</p>
          </div>
        ) : error ? (
          <div className="empty-state">
            <div className="empty-icon">⚠️</div>
            <p>{error}</p>
          </div>
        ) : !contact ? (
          <div className="empty-state">
            <div className="empty-icon">📞</div>
            <h3>No Contact Details</h3>
          </div>
        ) : (
          <div className="table-container">
            <table className="bet-history-table">
              <thead>
                <tr>
                  <th>TYPE</th>
                  <th>DETAIL</th>
                </tr>
              </thead>

              <tbody>
                {/* Mobile */}
                {hasValidValue(contact.mobile_1) && (
                  <tr>
                    <td>📱 Mobile</td>
                    <td>
                      <a href={`tel:${contact.mobile_1}`}>{contact.mobile_1}</a>
                    </td>
                  </tr>
                )}

                {/* WhatsApp */}
                {hasValidValue(contact.whatsapp_no) && (
                  <tr>
                    <td>💬 WhatsApp</td>
                    <td>
                      <a
                        href={`https://wa.me/${contact.whatsapp_no.replace(/\D/g, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {contact.whatsapp_no}
                      </a>
                    </td>
                  </tr>
                )}

                {/* Telegram - Note: API uses telegram_no and telegram_username */}
                {hasValidValue(contact.telegram_username) && (
                  <tr>
                    <td>📨 Telegram</td>
                    <td>
                      <a
                        href={`https://t.me/${cleanTelegramUsername(contact.telegram_username).replace('@', '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {cleanTelegramUsername(contact.telegram_username)}
                      </a>
                    </td>
                  </tr>
                )}

                {/* Telegram Number (if username not available) */}
                {!hasValidValue(contact.telegram_username) && hasValidValue(contact.telegram_no) && (
                  <tr>
                    <td>📨 Telegram</td>
                    <td>
                      <a
                        href={`https://t.me/${contact.telegram_no}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {contact.telegram_no}
                      </a>
                    </td>
                  </tr>
                )}

             
              
             


              </tbody>
            </table>

            <div className="table-footer">
              <div className="footer-info">
                ⏰ Support available 24/7
               
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUs;